import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { STATIC } from '../../lib/queryPresets';
import { useAuthStore } from '../../store/useAuthStore';
import {
  getMyOutlookConnection,
  disconnectOutlook,
} from '../../services/outlook/outlookConnectionService';

export function useOutlookConnection() {
  const collaboratorId = useAuthStore((s) => s.collaborator?.id);
  return useQuery({
    ...STATIC,
    queryKey: ['outlook', 'connection', collaboratorId],
    queryFn: () => getMyOutlookConnection(collaboratorId!),
    enabled: !!collaboratorId,
  });
}

export function useDisconnectOutlook() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: disconnectOutlook,
    onSuccess: () => qc.invalidateQueries({ queryKey: ['outlook', 'connection'] }),
    onError: () => toast.error('Déconnexion échouée. Réessayez.'),
  });
}
